import * as React from 'react'
import RiderSearch from '../../containers/trips/RiderSearch'
import TripZoneSelector from '../../containers/trips/TripZoneSelector'
import TripsDashboard from '../../containers/trips/TripsDashboard'
import Weather from '../../containers/navigation/Weather'
export interface ITrips {
  location: any
  value: string
  setCurrentTripStage: () => void
  showOrgServiceArea: () => void
}
const Trips = (props: ITrips) => {
  // props.setCurrentTripStage()
  return (
    <React.Fragment>
      <Weather orgId={''} orgName={''} userName={''} isAdmin={false} {...props} />
      <RiderSearch activeRidersOnly={true} />
      {!props.value && <TripsDashboard {...props} />}
    </React.Fragment>
  )
}
export default Trips



// WEBPACK FOOTER //
// ./src/components/trips/Trips.tsx